import React from "react"
import cn from "classnames"
import compose from "ramda/es/compose"
import { Box } from "@infotech/uikit-grid"
import {
  filterConstraintTypesByCategory,
  constraintTypeAPI,
  categoryAPI,
} from "../helpers"
import CategoryList from "../CategoryList"
import styles from "./styles.css"

const ConstraintTypeOption = props => {
  const { label, onClick, isSelected } = props

  return (
    <li
      className={cn(styles.constraintTypeOption, {
        [styles.constraintTypeOptionSelected]: isSelected,
      })}
    >
      <Box
        p="2md"
        flex
        justify="space-between"
        align="center"
        bb
        onClick={onClick}
      >
        {label}
      </Box>
    </li>
  )
}

const mapConstraintTypesToOptions = (
  constraintTypes,
  clickHandler,
  selectedConstraintType,
) =>
  constraintTypes.map(constraintType => (
    <ConstraintTypeOption
      key={constraintTypeAPI.getId(constraintType)}
      label={constraintTypeAPI.getName(constraintType)}
      isSelected={
        selectedConstraintType &&
        constraintTypeAPI.getId(selectedConstraintType) ===
          constraintTypeAPI.getId(constraintType)
      }
      onClick={() => clickHandler(constraintType)}
    />
  ))

export default props => {
  const {
    constraintTypes,
    onOptionClick,
    categories,
    selectedConstraintType,
    onGroupClick,
    expandedCategories,
  } = props

  // Reducing the number of args
  const mapConstraintTypes = constraintTypes =>
    mapConstraintTypesToOptions(
      constraintTypes,
      onOptionClick,
      selectedConstraintType,
    )

  const filterConstraintTypes = category =>
    filterConstraintTypesByCategory(constraintTypes, category)

  return (
    <CategoryList
      categories={categories}
      expandedCategories={expandedCategories}
      onGroupClick={onGroupClick}
      renderCategoryLabel={category =>
        `${categoryAPI.getName(category)} (${
          filterConstraintTypes(category).length
        })`
      }
      renderCategoryChildren={category => (
        <ul className={styles.UnderListStyles}>
          {compose(mapConstraintTypes, filterConstraintTypes)(category)}
        </ul>
      )}
    />
  )
}
